import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { MessageService } from 'primeng/api';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CountryService } from './_legacy/service/country.service';
import { EventService } from './_legacy/service/event.service';
import { IconService } from './_legacy/service/icon.service';
import { NodeService } from './_legacy/service/node.service';
import { PhotoService } from './_legacy/service/photo.service';
import { AuthInterceptor } from './core/interceptor/auth.interceptor';
import { LoaderInterceptor } from './core/interceptor/loader.interceptor';

/**
 * Phase 8 — slim bootstrap module.
 *
 * AppComponent and every feature/layout component are now standalone.
 * AppModule exists only to wire up `BrowserModule`, `BrowserAnimationsModule`,
 * `HttpClientModule`, the HTTP interceptors, and the `_legacy/` Sakai-template
 * services that still use bare `@Injectable()` (without `providedIn: 'root'`).
 */
@NgModule({
  imports: [BrowserModule, BrowserAnimationsModule, HttpClientModule, AppRoutingModule, AppComponent],
  providers: [
    // Loader fires before Auth so the spinner appears for every non-auth
    // request, regardless of token state. Auth then adds the bearer or
    // short-circuits with EMPTY (which Loader's `finalize` still drains).
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    // Demo services from the PrimeNG Sakai template — quarantined to
    // `_legacy/` and registered here only because the bare `@Injectable()`
    // decorator demands a module provider. Removed when the demo routes
    // (`utilities/icons`, etc.) are deleted.
    CountryService,
    EventService,
    IconService,
    NodeService,
    PhotoService,
    MessageService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
